import React from 'react';
import { Link } from 'react-router-dom';
import {
  Home, Tag, Key, Gem, TrendingUp, Shield,
  Hammer, Sparkles, Truck, Users,
} from 'lucide-react';
import { Button } from './ui/button';
import { siteData } from '../mockData';

const iconMap = {
  home: Home,
  tag: Tag,
  key: Key,
  gem: Gem,
  trending: TrendingUp,
  shield: Shield,
  hammer: Hammer,
  sparkles: Sparkles,
  truck: Truck,
  users: Users,
};

const HOME_FEATURED = ['BUYING', 'SELLING', 'FIRST-TIME HOME BUYERS', 'VA LOANS & MILITARY RELOCATION'];

const ServicesSection = () => {
  return (
    <section className="py-24 bg-[#0a0a0a] relative overflow-hidden">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_30%_50%,rgba(255,255,255,0.03),transparent_70%)]"></div>
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <p className="text-xs tracking-[0.3em] text-gray-500 uppercase mb-4">What We Do</p>
          <h2 className="text-4xl md:text-5xl font-light text-white mb-6">
            Delivering successful outcomes<br className="hidden md:block" /> in every transaction
          </h2>
          <div className="w-16 h-[1px] bg-white/30 mx-auto mb-6"></div>
          <p className="text-base text-gray-400 max-w-2xl mx-auto">
            Mazen has spent years honing his craft and is an expert in creating successful strategies 
            for finding your dream home or getting the highest possible price on your property.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 mb-14 max-w-4xl mx-auto">
          {siteData.services
            .filter((s) => HOME_FEATURED.includes(s.title))
            .map((service) => {
            const IconComponent = iconMap[service.icon] || Home;
            return (
              <div 
                key={service.id}
                className="group cursor-pointer"
              >
                <div className="border border-white/10 rounded-xl p-8 backdrop-blur-sm bg-white/[0.02] hover:bg-white/[0.05] hover:border-white/20 transition-all duration-500">
                  <div className="flex items-start gap-5">
                    <div className="w-14 h-14 rounded-full bg-white/10 flex items-center justify-center shrink-0 group-hover:bg-white/15 transition-colors duration-500">
                      <IconComponent className="text-white/80" size={24} />
                    </div>
                    <div>
                      <h3 className="text-sm font-semibold tracking-widest text-white mb-2">
                        {service.title}
                      </h3>
                      <p className="text-sm text-gray-500 leading-relaxed">{service.description}</p>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        <div className="text-center">
          <Link to="/services">
            <Button
              variant="outline"
              size="lg"
              className="border border-white/30 text-white hover:bg-white hover:text-black transition-all duration-500 rounded-full px-10 bg-transparent">
              SEE ALL SERVICES
            </Button>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
